import React from 'react';
import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { CodeHighlighter } from '@uhg-abyss/web/ui/CodeHighlighter';
import { Link } from '@uhg-abyss/web/ui/Link';

import { constants } from '@src/common/Utils/Constants';

export const APIOverviewContent = ({ content }) => {
  const customStyle = {
    width: '100%', // Adjust the width
    height: 'auto', // Adjust the height
    // margin: '50px auto', // Center the div horizontally
    padding: '10px', // Add padding
    // Add a border
    // Center the text
  };
  const BulletedList = styled('ul', {
    listStyleType: 'revert',
    marginBottom: '20px',
    color: constants.FONT_COLOR_BLACK,
    paddingLeft: '40px',
    fontSize: '15px',
  });

  const PageSecondaryHeading = styled('h2', {
    color: '#002677',
    marginBottom: '20px !important',
    lineHeight: '29px !important',
    fontSize: '24px ! important',
  });
  const PageHeading = styled('h1', {
    marginBottom: '20px !important',
    marginTop: '20px !important',
  });
  const PageDesc = styled('p', {
    color: constants.FONT_COLOR_BLACK,
    fontSize: '15px',
    fontWeight: 400,
    letterSpacing: '0px',
    lineHeight: '20px',
    marginBottom: '20px',
    whiteSpace: 'pre-line',
  });
  const bulletPointStyle = styled('li', {
    fontWeight: 'normal',
    fontSize: '15px',
  });
  const NumberedList = styled('ol', {
    listStyleType: 'decimal',

    color: constants.FONT_COLOR_BLACK,
    padding: '0px 0px 0px 40px',
  });

  const StyledLink = styled(Link, {
    fontSize: '24px !important',
    fontFamily: 'AbyssUHCSerif',
  });

  return (
    <Markdown
      style={customStyle}
      options={{
        overrides: {
          ul: BulletedList,
          li: bulletPointStyle,
          ol: NumberedList,
          h1: PageHeading,

          h2: PageSecondaryHeading,
          p: PageDesc,
          code: {
            component: ({ children }) => {
              return <CodeHighlighter code={children} language="js" />;
            },
          },
          a: {
            component: ({ children, href }) => {
              return <StyledLink href={href}>{children}</StyledLink>;
            },
          },
          span: {
            component: ({ children }) => {
              return <span>{children}</span>;
            },
          },
          img: ({ id, ...props }) => {
            // Extract the id attribute
            if (id === 'Badge') {
              return (
                <Badge
                  variant="neutral"
                  outline
                  style={{
                    display: 'inline',
                    marginLeft: '10px',

                    padding: '1px 5px 0px 4px', // Ensure the Badge is inline
                    // Add spacing between text and Badge
                    fontSize: '14px',
                    fontFamily: 'Enterprise Sans',
                    fontWeight: 'bold !important',
                  }}
                  ariaText="information"
                >
                  Coming soon
                </Badge>
              );
            }
            // Return the actual image with all original props
            return <img alt={id} id={id} {...props} />;
          },
          div: {
            component: ({ children, id }) => {
              // Check if the ID exists and includes 'accordion'
              if (id && id.includes('accordion')) {
                // Ensure children is an array and dynamically extract content
                const contentArray = children?.slice(1)?.map((child, index) => {
                  return child?.props?.children?.[0] || null;
                });
                const title =
                  children?.[0]?.props?.children?.[0] || 'Accordion Title';

                return (
                  <Accordion
                    isCollapsible
                    css={{
                      '.abyss-accordion-content-text div': {
                        color: '#000000',
                      },
                    }}
                  >
                    <Accordion.Item value={title}>
                      <Accordion.Trigger
                        style={{
                          fontWeight: 'bold',
                          fontSize: '16px',
                        }}
                      >
                        <Accordion.Header>{title}</Accordion.Header>
                      </Accordion.Trigger>
                      <Accordion.Content>
                        {contentArray?.map((subCon, index) => {
                          return <div>{subCon}</div>;
                        })}
                      </Accordion.Content>
                    </Accordion.Item>
                  </Accordion>
                );
              }

              // Render default div for other IDs
              return <div id={id}>{children}</div>;
            },
          },
        },
      }}
    >
      {content}
    </Markdown>
  );
};

APIOverviewContent.propTypes = {
  content: PropTypes.string.isRequired,
};
